import GiftCardRefund from '@/components/RefundUIs/GiftCardRefund';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/digital-payments',
)({
  component: DigitalPayment,
});

function DigitalPayment() {
  return <GiftCardRefund type='digitalpayments' />;
}
